import * as React from 'react'
import Button from '@mui/material/Button'
import { styled } from '@mui/material/styles'

const ActionsDiv = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  height: 40,
}))

type BtnColors =
  | 'inherit'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'error'
  | 'info'
  | 'warning'
interface Props {
  onActionLeft: () => void
  disabledLeft?: boolean
  textLeft: string
  colorLeft: BtnColors
  colorRight: BtnColors
  textRight: string
  disabledRight?: boolean
  hideLeft?: boolean
  onActionRight: () => void
  leftIcon: React.ReactNode
  rightIcon: React.ReactNode
  leftVariant: 'text' | 'outlined' | 'contained'
  rightVariant: 'text' | 'outlined' | 'contained'
}
export const ActionsDivComponent: React.FC<Props> = ({
  onActionLeft,
  disabledLeft,
  disabledRight,
  hideLeft,
  onActionRight,
  textLeft,
  textRight,
  colorLeft,
  colorRight,
  leftIcon,
  rightIcon,
  leftVariant,
  rightVariant,
}) => (
  <ActionsDiv>
    {hideLeft ? (
      <div />
    ) : (
      <Button
        color={colorLeft}
        variant={leftVariant}
        onClick={onActionLeft}
        disabled={disabledLeft}
        startIcon={leftIcon}
      >
        {textLeft}
      </Button>
    )}

    <Button
      variant={rightVariant}
      onClick={onActionRight}
      disabled={disabledRight}
      color={colorRight}
      startIcon={rightIcon}
    >
      {textRight}
    </Button>
  </ActionsDiv>
)
